import { fetchWithState, getFetchedJSON } from "~/misc/fetch";
import { ActionError } from "~/misc/dispatch";

export const createPostTruckAPI = (getState, createData) =>
  fetchWithState(getState, {
    method: "POST",
    url: "/tl/post-truck/mine/create",
    body: createData,
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });

export const deletePostTruckAPI = (getState, postTruckId) =>
  fetchWithState(getState, {
    method: "DELETE",
    url: `/tl/post-truck/mine/delete/${postTruckId}`,
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });

export const deletePostTrucksAPI = (getState, postTruckIds) =>
  fetchWithState(getState, {
    method: "DELETE",
    url: `/tl/post-truck/mine/delete/patch?ids=${postTruckIds}`,
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });

export const updatePostTruckAPI = (getState, updateData) =>
  fetchWithState(getState, {
    method: "PUT",
    url: `/tl/post-truck/mine/update`,
    body: updateData,
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });

export const getPostTruckListAPI = (getState, getData) =>
  // sortBy : AGE PICKUP EQUIPMENT DROP_OFF
  // order : ASC DESC
  fetchWithState(getState, {
    method: "GET",
    url: `/tl/post-truck/mine/list/v2?page=${getData.page}&pageSize=${getData.pageSize}&sortBy=${getData.sortBy}&order=${getData.order}`,
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });

export const getDistanceAPI = (getState, getData) =>
  fetchWithState(getState, {
    method: "GET",
    url: `/v1/search/loads/distance?fromLng=${getData.fromLng}&fromLat=${getData.fromLat}&toLng=${getData.toLng}&toLat=${getData.toLat}`,
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });

export const getRate = (getState, getData) =>
  fetchWithState(getState, {
    method: "POST",
    url: `/tl/rate/getCheck`,
    body: getData,
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });



// WEBPACK FOOTER //
// ./src/pages/PostTruck/apis/posttruck.js